import React from 'react';
import { Divider, Tooltip, Zoom } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const PurchaseSummary = ({
  tarifasSeleccionadas,
  cantidad,
  calculoSubtotalTarifa,
  subtotal,
  comision,
  hayComision,
  total,
  formatCurrency,
  isMobile = false
}) => {
  return (
    <div className="" style={{ flex: 1, paddingRight: isMobile ? "0px" : "28px" }}>
      <p style={{
        color: "#221A60",
        fontSize: isMobile ? "18px" : "20px",
        marginBottom: "5px"
      }}>
        {isMobile ? "Resumen de tu compra" : "Tu compra"}
      </p>
      <div className={`d-flex flex-column ${isMobile ? "px-0" : "px-3"} pt-4`}>
        <div className="mb-3">
          {tarifasSeleccionadas?.length > 0 ? (
            tarifasSeleccionadas.map((tarifa) => (
              <div key={tarifa.id} className="mb-2">
                <div className={`d-flex justify-content-between align-items-center py-1 ${isMobile ? "flex-wrap" : ""}`}>
                  <span className={isMobile ? "fw-medium" : ""}>{`${cantidad[tarifa.id]} x ${tarifa.concepto}`}</span>
                  <span className={isMobile ? "fw-medium" : ""}>$ {formatCurrency(calculoSubtotalTarifa(tarifa))}</span>
                </div>
                {tarifa.requiere_aprobacion && (
                  <span style={{ fontSize: "12px", color: "#5656ff", fontWeight: 500 }}>
                    Requiere aprobación del organizador
                  </span>
                )}
              </div>
            ))
          ) : (
            <p className="mb-0">No hay tarifas seleccionadas</p>
          )}
        </div>

        {tarifasSeleccionadas?.length > 0 && (
          <>
            <Divider variant="middle" sx={{ backgroundColor: isMobile ? "#D9D9D9" : "black" }} />
            <div className={`d-flex flex-column ${hayComision ? "py-4" : " pt-3"}`}>
              <div className={`d-flex flex-row justify-content-between ${isMobile ? "flex-wrap py-2" : ""}`}>
                <p className={`mb-3 ${isMobile ? "fw-medium fs-5 mb-0" : ""}`}>Subtotal</p>
                <p className={`mb-3 ${isMobile ? "fw-medium fs-5 mb-0" : ""}`}>$ {formatCurrency(subtotal)}</p>
              </div>
              {hayComision && (
                <div className={`d-flex flex-row justify-content-between ${isMobile ? "flex-wrap py-2" : ""}`}>
                  <div className="d-flex flex-row align-items-center">
                    <p className={`mb-0 ${isMobile ? "fw-medium fs-5" : ""}`}>Costo</p>
                    <Tooltip
                      arrow
                      TransitionComponent={Zoom}
                      placement="right"
                      title="El costo de servicio de PassGo no es reembolsable"
                    >
                      <InfoOutlined sx={{ width: "18px", height: "18px", marginLeft: "5px" }} />
                    </Tooltip>
                  </div>
                  <p className={`mb-0 ${isMobile ? "fw-medium fs-5" : ""}`}>$ {formatCurrency(comision)}</p>
                </div>
              )}
            </div>
            <Divider variant="middle" sx={{ backgroundColor: isMobile ? "#D9D9D9" : "black" }} />
            <div className={`d-flex flex-row justify-content-between py-4 ${isMobile ? "flex-wrap py-2" : ""}`}>
              <p className={`fw-bold ${isMobile ? "mb-0 fs-3" : "mb-3"}`}>Total</p>
              <div className="d-flex flex-column text-right">
                <p className={`mb-0 ${isMobile ? "fs-3" : ""}`}>$ {formatCurrency(total)}</p>
                <span className="fw-light" style={{ fontSize: "14px" }}>
                  {isMobile ? "El precio incluye impuestos" : "El precio incluye impuestos"}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PurchaseSummary;